import { LOGGED_IN, LOGOUT } from "app/utils/constants/authActions";
import { store } from "../store";
import { userJwtData, setEmptyUser } from "./userAction";

export const loginAction = (data) => {
    userJwtData(data)
    store.dispatch({
        type: LOGGED_IN,
        payload: data
    })
}

export const logoutAction = () => {
    sessionStorage.clear();
    setEmptyUser()
    store.dispatch({
        type: LOGOUT
    })
}